export const CONTRIBUTIONS_CONNECTION_TYPE_CONTRIBUTIONS = "contributionsConnections";
export const CONTRIBUTIONS_CONNECTION_TYPE_MARKERS = "markersConnections";

export const STORE_CONTRIBUTIONS_CONNECTION_ID = "STORE_CONTRIBUTIONS_CONNECTION_ID";

export function storeContributionsConnection(
  contribuable,
  connectionType,
  connectionDetails
) {
  return {
    type: STORE_CONTRIBUTIONS_CONNECTION_ID,
    contribuable,
    connectionType,
    connectionDetails
  };
}

function storeContributionsConnectionHandler(
  state,
  contribuable,
  connectionType,
  connectionDetails
) {
  const { id: contribuableId } = contribuable;
  const newContribuableConnectionState = state[contribuableId]
    ? { ...state[contribuableId] }
    : {};
  const newConnectionTypeState = newContribuableConnectionState[connectionType]
    ? [...newContribuableConnectionState[connectionType]]
    : [];

  newConnectionTypeState.push(connectionDetails);

  return {
    ...state,
    [contribuableId]: {
      ...newContribuableConnectionState,
      [connectionType]: newConnectionTypeState
    }
  };
}

export default function contributionsConnectionsReducer(state, action) {
  switch (action && action.type) {
    case STORE_CONTRIBUTIONS_CONNECTION_ID:
      return storeContributionsConnectionHandler(
        state,
        action.contribuable,
        action.connectionType,
        action.connectionDetails
      );

    default:
      return state || {};
  }
}
